import * as React from 'react'

export interface ISettingsProps {}

export default class Settings extends React.Component<ISettingsProps> {
  public render() {
    return <div></div>
  }
}
